import * as React from 'react';
import classnames from 'classnames';
import { Select } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import { getEyeLabel } from '../utils.js';
import { getCLSelectedQuantityValue } from './helpers.js';

const SelectQuantity = ({ parentId , isDisabled , options , onChange , selectedQuantity , showLabel , className ,  })=>{
    const intl = useIntl();
    const selectId = `${parentId}-quantity-select`;
    const eyeLabel = getEyeLabel(intl, parentId);
    const label = intl.getLabel('products.contactLenses.quantitySelect.label');
    const initialSelection = getCLSelectedQuantityValue(options, selectedQuantity);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, showLabel && /*#__PURE__*/ React.createElement("label", {
        className: classnames('select-quantity__label', `${className}__label`),
        htmlFor: selectId
    }, label), /*#__PURE__*/ React.createElement(Select, {
        id: selectId,
        name: "quantity-selector",
        "aria-label": `${label} ${eyeLabel}`,
        className: classnames('select-quantity__select', className),
        options: options,
        initialState: initialSelection,
        disabled: isDisabled,
        onChange: onChange,
        "data-t": "select-quantity"
    }));
};

export { SelectQuantity };
//# sourceMappingURL=SelectQuantity.js.map
